import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ChancePO} from "@/model/customer";
import {WriteChanceForm} from "@/pages/Chance/WriteChance";
import {SearchBO} from "@/service/common.s";

export enum ChanceEnum {
    GetChancePage = "/chance/getChancePage",
    GetChance = "/chance/getChance",
    CreateChance = "/chance/createChance",
    UpdateChance = "/chance/updateChance",
    SearchChance = "/chance/searchChance",
}

export interface ChancePageBO {
    keyword?: string;
}

export interface SearchChanceVO extends ChancePO {
    names: string;
}

// 商机分页
export const useQueryChancePage = () => useMutation<BaseVO<PaginationVO<ChancePO>>, null, ChancePageBO>({
        mutationFn: (data: ChancePageBO) => http.post<BaseVO<PaginationVO<ChancePO>>>({
            url: ChanceEnum.GetChancePage,
            data: data,
        }),
    })
;

// 创建商机
export const useCreateChance = () => useMutation({
    mutationFn: (data: WriteChanceForm) => http.put<BaseVO<null>>({url: ChanceEnum.CreateChance, data}),
})

// 修改商机
export const useUpdateChance = () => useMutation({
    mutationFn: (data: WriteChanceForm) => http.post<BaseVO<null>>({url: ChanceEnum.UpdateChance, data}),
})

// 查询商机
export const useQueryChance = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<ChancePO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<ChancePO>>({
        url: ChanceEnum.GetChance,
        params: params
    }), enabled
})

// 搜索商机
export const useSearchChance = () => useMutation({mutationFn: (data: SearchBO) => http.post<BaseVO<SearchChanceVO[]>>({url: ChanceEnum.SearchChance, data})})


